<template>
  <div class="addPatient" v-if="showPage">
    <div class="group1">
      <van-cell-group :border="false" style="margin-bottom: 20px;">
        <div class="title">请输入个人基础信息</div>
        <van-field v-model="formData.name" label="姓名" :required="!nameReadonly" :readonly="nameReadonly" placeholder="请输入姓名" input-align="right" type="text"></van-field>
        <van-field v-model="formData.mobile" label="手机号码" :required="!mobileReadonly" :readonly="mobileReadonly" :error="mobileErr1" placeholder="请输入手机号码" input-align="right" @blur="checkMobile(formData.mobile, 1)"></van-field>

        <van-field v-model="idsnType" label="证件类型" :required="!idsnReadonly" readonly placeholder="请输入您的证件类型" input-align="right"></van-field>

        <van-field v-model="formData.idsn" label="证件号码" :required="!idsnReadonly" :readonly="idsnReadonly" :error="idsnErr" placeholder="请输入您的证件号码" input-align="right" @blur="checkIdsn(formData.idsn)"></van-field>
      </van-cell-group>
    </div>
    <div class="" v-if="allReadOnly">
      <van-cell-group style="margin-bottom: 10px;" class="group2">
        <div class="title">请依次选择省市、医院、药房、医生、公益专员</div>

        <van-cell :value="provinceName" class="inputone" title="所属省份" required>
          <template>
            <div :style="{ color: provinceName == '请选择所属省份' ? '#969799' : '#323233' }">{{ provinceName }}</div>
          </template>
        </van-cell>

        <van-cell :value="cityName" class="inputone" title="所属城市" required>
          <template>
            <div :style="{ color: cityName == '请选择所属城市' ? '#969799' : '#323233' }">{{ cityName }}</div>
          </template>
        </van-cell>

        <van-cell :value="hospitalName" class="inputone" title="项目医院">
          <template>
            <div :style="{ color: hospitalName == '请选择项目医院' ? '#969799' : '#323233' }">{{ hospitalName }}</div>
          </template>
        </van-cell>

        <van-cell :value="drugstoreName" class="inputone" title="项目药房">
          <template>
            <div :style="{ color: drugstoreName == '请选择项目药房' ? '#969799' : '#323233' }">{{ drugstoreName }}</div>
          </template>
        </van-cell>

        <van-cell :value="doctorName" class="inputone" title="项目医生">
          <template>
            <div :style="{ color: doctorName == '请选择项目医生' ? '#969799' : '#323233' }">{{ doctorName }}</div>
          </template>
        </van-cell>

        <van-cell :value="staffName" class="inputone" title="公益专员" required>
          <template>
            <div :style="{ color: staffName == '请选择公益专员' ? '#969799' : '#323233' }">{{ staffName }}</div>
          </template>
        </van-cell>
      </van-cell-group>

      <van-cell-group style="margin-bottom: 10px;" class="group3">
        <van-cell :value="modeName" class="inputone" title="患者类型" required>
          <template>
            <div :style="{ color: modeName == '请选择患者类型' ? '#969799' : '#323233' }">{{ modeName }}</div>
          </template>
        </van-cell>

        <van-cell :value="patientType" class="inputone" title="疾病类型" required>
          <template>
            <div :style="{ color: patientType == '请选择疾病类型' ? '#969799' : '#323233' }">{{ patientType }}</div>
          </template>
        </van-cell>

        <van-cell v-if="patientType !== '请选择疾病类型' && noCheckPatientType" :value="diseaseStage" class="inputone" title="疾病分期" required>
          <template>
            <div :style="{ color: diseaseStage == '请选择疾病分期' ? '#969799' : 'black' }">{{ diseaseStage }}</div>
          </template>
        </van-cell>

        <van-cell :value="startTreatment" class="inputone" title="是否开始治疗" required>
          <template>
            <div :style="{ color: startTreatment == '请选择' ? '#969799' : '#323233' }">{{ startTreatment }}</div>
          </template>
        </van-cell>

        <van-cell v-if="showFirstTreatmentDate" :value="FirstTimeStr" class="inputone" title="选择第一次治疗时间" required>
          <template>
            <div :style="{ color: FirstTimeStr == '请选择' ? '#969799' : '#323233' }">{{ FirstTimeStr }}</div>
          </template>
        </van-cell>

        <van-cell :value="timeStr" class="inputone noborder" title="选择最近一次输注时间" required>
          <template>
            <div :style="{ color: timeStr == '请选择' ? '#969799' : '#323233' }">{{ timeStr }}</div>
          </template>
        </van-cell>
        <van-cell v-if="showNextTimeCell" class="inputone" style="color:red;padding-top:0;">
          <template #title>
            <span>下一次的输注时间为{{ nextTime }}</span>
          </template>
        </van-cell>
      </van-cell-group>

      <van-cell-group style="margin-bottom: 10px;" class="group4">
        <van-field v-model="formData.field_7" class="nowrap" label="紧急联系人姓名" input-align="right" readonly></van-field>
        <van-field v-model="formData.field_8" class="nowrap" label="紧急联系人电话" input-align="right" :error="mobileErr2" readonly></van-field>
      </van-cell-group>

      <van-cell-group style="margin-bottom: 10px;" class="group5">
        <van-cell class="" required>
          <template #title>
            <div>患者本人人脸照片</div>
            <van-image width="10rem" height="10rem" fit="cover" :src="formData.photo" @click="showPic([{ filepath: formData.photo }])" />
          </template>
        </van-cell>
      </van-cell-group>
    </div>

    <div class="" v-else>
      <van-cell-group style="margin-bottom: 10px;" class="group2">
        <div class="title">请依次选择省市、医院、药房、医生、公益专员</div>

        <van-cell :value="provinceName" class="inputone" title="所属省份" required is-link @click="openProvince">
          <template>
            <div :style="{ color: provinceName == '请选择所属省份' ? '#969799' : '#323233' }">{{ provinceName }}</div>
          </template>
        </van-cell>
        <van-popup v-model="showProvince" round position="bottom">
          <van-picker show-toolbar :columns="provinceArr" @cancel="showProvince = false" @confirm="onProvince" />
        </van-popup>

        <van-cell :value="cityName" class="inputone" title="所属城市" required is-link @click="openCity">
          <template>
            <div :style="{ color: cityName == '请选择所属城市' ? '#969799' : '#323233' }">{{ cityName }}</div>
          </template>
        </van-cell>
        <van-popup v-model="showCity" round position="bottom">
          <van-picker show-toolbar :columns="cityArr" @cancel="showCity = false" @confirm="onCity" />
        </van-popup>

        <van-cell :value="hospitalName" class="inputone" title="项目医院" is-link @click="openHospital">
          <template>
            <div :style="{ color: hospitalName == '请选择项目医院' ? '#969799' : '#323233' }">{{ hospitalName }}</div>
          </template>
        </van-cell>
        <van-popup v-model="showHospital" round position="bottom">
          <van-picker show-toolbar :columns="hospitalArr" value-key="name" @cancel="showHospital = false" @confirm="onHospital" />
        </van-popup>

        <van-cell :value="drugstoreName" class="inputone" title="项目药房" is-link @click="openDrugstore">
          <template>
            <div :style="{ color: drugstoreName == '请选择项目药房' ? '#969799' : '#323233' }">{{ drugstoreName }}</div>
          </template>
        </van-cell>
        <van-popup v-model="showDrugstore" round position="bottom">
          <van-picker show-toolbar :columns="drugstoreArr" value-key="name" @cancel="showDrugstore = false" @confirm="onDrugstore" />
        </van-popup>

        <van-cell :value="doctorName" class="inputone" title="项目医生" is-link @click="openDoctor">
          <template>
            <div :style="{ color: doctorName == '请选择项目医生' ? '#969799' : '#323233' }">{{ doctorName }}</div>
          </template>
        </van-cell>
        <van-popup v-model="showDoctor" round position="bottom">
          <van-picker show-toolbar :columns="doctorArr" value-key="name" @cancel="showDoctor = false" @confirm="onDoctor" />
        </van-popup>

        <van-cell :value="staffName" class="inputone" title="公益专员" required>
          <template>
            <div :style="{ color: staffName == '请选择公益专员' ? '#969799' : '#323233', 'padding-right': '20px' }">{{ staffName }}</div>
          </template>
        </van-cell>
        <van-popup v-model="showStaff" round position="bottom">
          <van-picker show-toolbar :columns="staffArr" value-key="name" @cancel="showStaff = false" @confirm="onStaff" />
        </van-popup>
      </van-cell-group>

      <van-cell-group style="margin-bottom: 10px;" class="group3">
        <van-cell :value="modeName" class="inputone" title="患者类型" required is-link @click="openDiseaseType">
          <template>
            <div :style="{ color: modeName == '请选择患者类型' ? '#969799' : '#323233' }">{{ modeName }}</div>
          </template>
        </van-cell>
        <van-popup v-model="showMode" round position="bottom">
          <van-picker show-toolbar :columns="modeArr" value-key="name" @cancel="showMode = false" @confirm="onMode" />
        </van-popup>

        <van-cell :value="patientType" class="inputone" title="疾病类型" required is-link @click="openPatientType">
          <template>
            <div :style="{ color: patientType == '请选择疾病类型' ? '#969799' : '#323233' }">{{ patientType }}</div>
          </template>
        </van-cell>
        <van-popup v-model="showPatientType" round position="bottom">
          <van-picker show-toolbar :columns="patientTypeArr" value-key="name" @cancel="showPatientType = false" @confirm="onPatientType" />
        </van-popup>

        <van-cell v-if="patientType !== '请选择疾病类型' && noCheckPatientType" :value="diseaseStage" class="inputone" title="疾病分期" required is-link @click="openDiseaseStage">
          <template>
            <div :style="{ color: diseaseStage == '请选择疾病分期' ? '#969799' : 'black' }">{{ diseaseStage }}</div>
          </template>
        </van-cell>
        <van-popup v-model="showDiseaseStage" round position="bottom">
          <van-picker show-toolbar :columns="diseaseStageArr" value-key="name" @cancel="showDiseaseStage = false" @confirm="onDiseaseStage" />
        </van-popup>

        <van-cell :value="startTreatment" class="inputone" title="是否开始治疗" required is-link @click="openTreatment">
          <template>
            <div :style="{ color: startTreatment == '请选择' ? '#969799' : '#323233' }">{{ startTreatment }}</div>
          </template>
        </van-cell>
        <van-popup v-model="showTreatment" round position="bottom">
          <van-picker show-toolbar :columns="treatmentArr" value-key="name" @cancel="showTreatment = false" @confirm="onTreatment" />
        </van-popup>

        <van-cell v-if="showFirstTreatmentDate" :value="FirstTimeStr" class="inputone" title="选择第一次治疗时间" required is-link @click="openDatePicker(1)">
          <template>
            <div :style="{ color: FirstTimeStr == '请选择' ? '#969799' : '#323233' }">{{ FirstTimeStr }}</div>
          </template>
        </van-cell>
        <van-popup v-model="showDatePicker1" round position="bottom">
          <van-datetime-picker v-model="firstTreatmentDate" type="date" title="" :min-date="minDate" :max-date="maxDate" @confirm="onFirstTreatmentDate" @cancel="showDatePicker1 = false" />
        </van-popup>

        <van-cell :value="timeStr" class="inputone noborder" title="选择最近一次输注时间" required is-link @click="openDatePicker(2)">
          <template>
            <div :style="{ color: timeStr == '请选择' ? '#969799' : '#323233' }">{{ timeStr }}</div>
          </template>
        </van-cell>
        <van-cell v-if="showNextTimeCell" class="inputone" style="color:red;padding-top:0;">
          <template #title>
            <span>下一次的输注时间为{{ nextTime }}</span>
          </template>
        </van-cell>
        <van-popup v-model="showDatePicker2" round position="bottom">
          <van-datetime-picker v-model="latestTreatmentDate" type="date" title="" :min-date="minDate" :max-date="maxDate" @confirm="onLatestTreatmentDate" @cancel="showDatePicker2 = false" />
        </van-popup>

        <van-popup v-model="showNextTime" round style="width:80vw;padding:20px;padding-bottom:10px;font-size:13px;border-radius:6px;">
          <div style="display:flex;justify-content:center;margin:10px 0 20px 0;">
            <!-- 您最近一次的输注时间{{timeStr}}，<br/>
            由此推算出：<br/>
            您下一次的输注时间为{{nextTime}}<br/> -->
            温馨提醒：按您最近一次用药时间，预计您的下次输注时间为：{{ nextTime }}。请您合理安排援助申请时间。
          </div>
          <div class="btn">
            <van-button class="btn1" size="small" plain round @click="onCancel" color="#0AA8AF">取消</van-button>
            <van-button class="btn1" size="small" round @click="onNextTime" color="#0AA8AF">确认</van-button>
          </div>
        </van-popup>
      </van-cell-group>

      <van-cell-group style="margin-bottom: 10px;" class="group4">
        <van-field v-model="formData.field_7" class="nowrap" label="紧急联系人姓名" placeholder="请输入紧急联系人姓名" input-align="right"></van-field>
        <van-field v-model="formData.field_8" class="nowrap" label="紧急联系人电话" placeholder="请输入紧急联系人电话" input-align="right" :error="mobileErr2"></van-field>
      </van-cell-group>

      <van-cell-group style="margin-bottom: 10px;" class="group5">
        <van-cell class="" required>
          <template #title>
            <div>
              患者本人人脸照片
              <div style="color:red;margin-left:-8px;">（温馨提示：拍摄时面部不得遮挡，将五官清楚显露）</div>
            </div>
            <image-uploader ref="imgUploader" :value="photoArr" @input="getPhoto" title="" :num="1" @deleteCI="deleteCI"></image-uploader>
          </template>
        </van-cell>
      </van-cell-group>
    </div>

    <div class="btn" v-if="allReadOnly">
      <van-button class="btn2" :disabled="submitBtnDisabled" @click="$router.go(-1)" round color="#0AA8AF">返回</van-button>
    </div>
    <div class="btn" v-else>
      <van-button class="btn1" :disabled="submitBtnDisabled" plain @click="goTimeline" round color="#0AA8AF">返回首页</van-button>
      <van-button class="btn2" :disabled="submitBtnDisabled" @click="next" round color="#0AA8AF">提交</van-button>
    </div>
  </div>
</template>

<script>
import { checkin, Apply, GetProvince, GetCity, GetHospital, GetDoctor, GetDrugstore, GetMode, GetPatient, getVolunteers } from '@/api/api'
import ImageUploader from '@/views/apply/ImageUploader'
import { mapState } from 'vuex'
import { checkCellphone, getBirthById, getSexById, isIdCardNo } from '@/utils/utils'
import Vue from 'vue'
import { Toast, ImagePreview, Notify } from 'vant'

let hostname = window.location.hostname
hostname = hostname.substring(hostname.indexOf('.'))
let baseUrl = window.location.protocol + '//api' + hostname
Vue.use(ImagePreview)
Vue.use(Toast)
export default {
  components: { ImageUploader },
  data() {
    return {
      showPage: true,
      formData: {
        // patient_id: '',
        name: '',
        idsn: '',
        mobile: '',
        // gender: '',
        // birthday: '',
        province: '',
        city: '',
        hospital_id: '',
        drugstore_id: '',
        doctor_id: '',
        mode_id: '',
        field_1: '', //是否开始治疗
        field_2: '', //第一次治疗时间
        field_3: '', //疾病分期
        field_6: '', //疾病类型
        field_7: '', //紧急联系人姓名
        field_8: '', //紧急联系人电话
        phase_drug_field: { field_1: '' }, //阶段自定义字段
        volunteer_id: '',
        current_volunteer_id: '',
        photo: ''
      },

      mobileErr1: false,
      mobileErr2: false,
      idsnErr: false,
      nameReadonly: true,
      mobileReadonly: true,
      //证件类型
      idsnType: '身份证',
      showIdsnPicker: false,
      idsnReadonly: true,
      idsnArr: ['身份证'],

      //省份城市
      provinceArr: [],
      provinceName: '请选择所属省份',
      showProvince: false,
      cityArr: [],
      cityName: '请选择所属城市',
      showCity: false,

      drugstoreArr: [],
      drugstoreName: '请选择项目药房',
      showDrugstore: false,

      hospitalArr: [],
      hospitalName: '请选择项目医院',
      showHospital: false,

      doctorArr: [],
      doctorName: '请选择项目医生',
      showDoctor: false,

      staffName: '请选择公益专员',
      showStaff: false,
      staffArr: [],

      modeArr: [],
      modeName: '请选择患者类型',
      showMode: false,

      diseaseStage: '请选择疾病分期',
      showDiseaseStage: false,
      diseaseStageArr: ['Ⅳ期', 'Ⅲ期'],

      patientType: '请选择疾病类型',
      showPatientType: false,
      patientTypeArr: ['鳞状非小细胞肺癌', '非鳞状非小细胞肺癌', '淋巴瘤', '食管鳞癌', '胃癌'],
      noCheckPatientTypeArr: ['淋巴瘤', '食管鳞癌', '胃癌'],
      startTreatment: '请选择',
      treatmentArr: ['是', '否'],
      showTreatment: false,

      FirstTimeStr: '请选择', //第一次治疗时间
      showDatePicker1: false,
      showFirstTreatmentDate: false,
      firstTreatmentDate: new Date(),
      minDate: new Date(1949, 10, 1),
      maxDate: new Date(),

      timeStr: '请选择', //最近治疗时间
      showDatePicker2: false,
      latestTreatmentDate: new Date(),
      showNextTime: false,
      showNextTimeCell: false,

      lastTime: '',

      sourceType: ['camera'],
      photoArr: [],

      submitBtnDisabled: false,

      allReadOnly: false, //全部只读

      patient_id: '' //新增患者的时候
    }
  },
  watch: {
    startTreatment(a, b) {
      if (a == '是') this.showFirstTreatmentDate = true
      // console.log("startTreatment",a,b)
    }
  },
  computed: {
    ...mapState(['publicWelfareStaff']),
    nextTime() {
      // console.log(this.timeStr)
      let timeStr = this.timeStr.replace(/-/g, '/')
      // console.log(timeStr)
      let temp = new Date(timeStr)
      let x = 0 //年份
      let y = 0 //月份
      let z = 0 //日期
      temp.setFullYear(temp.getFullYear() + x)
      temp.setMonth(temp.getMonth() + y) //此处不加一
      temp.setDate(temp.getDate() + z + 21) //输注时间加21天
      // console.log('nextTime',temp)
      let year = temp.getFullYear()
      let month = temp.getMonth() + 1
      let day = temp.getDate()
      return year + '年' + month + '月' + day + '日'
      // return this.timeFormat(temp)//因为在timeFormat中会加一
    },
    noCheckPatientType() {
      return !this.noCheckPatientTypeArr.includes(this.patientType)
    }
  },
  async created() {
    if (this.$route.query.papid) this.papid = this.$route.query.papid
    await this.init()
    this.showPage = true
  },
  methods: {
    async init() {
      if (this.papid) {
        //已经填过资料or存在患者信息
        this.allReadOnly = true
        await this.GetData_RE() //回显
      } else {
        //新用户
        await this.GetData() //第一次进入
      }
    },
    async GetData_RE() {
      this.drugstoreName = ''
      this.hospitalName = ''
      this.doctorName = ''
      this.provinceName = ''
      this.cityName = ''
      this.patientType = ''
      this.startTreatment = ''
      this.FirstTimeStr = ''
      this.formData.field_7 = ''
      this.formData.field_8 = ''
      this.formData.photo = ''
      this.modeName = ''
      this.timeStr = ''

      console.log('当前addpatient页为 只读')
      let data = await GetPatient({ papid: this.papid })
      console.log('GetPatient接口返回:', data)
      let { doctor, drugstore, hospital, patient, volunteer, phase_drug_field, mode_name } = data.data
      if (patient) {
        this.formData.patient_id = patient.id
        this.formData.mobile = patient.mobile.substring(0, 4) + '****' + patient.mobile.substring(8, 12)
        this.formData.name = patient.name
        this.formData.idsn = patient.idsn.substring(0, 11) + '****' + patient.idsn.substring(15, 18)
        this.provinceName = patient.province
        this.cityName = patient.city

        this.patientType = patient.field_6.substring(patient.field_6.indexOf('期') + 1)
        if (patient.field_6) {
            this.diseaseStage =  patient.field_6.replace(this.patientType, '')
        }
        this.startTreatment = patient.field_1
        this.FirstTimeStr = patient.field_2

        this.formData.field_7 = patient.field_7
        this.formData.field_8 = patient.field_8

        this.formData.photo = patient.photo
      }
      if (drugstore) this.drugstoreName = drugstore.name
      if (hospital) this.hospitalName = hospital.name
      if (doctor) this.doctorName = doctor.name
      if (volunteer) this.staffName = volunteer.name

      if (mode_name) this.modeName = mode_name

      if (phase_drug_field) this.timeStr = phase_drug_field.field_1

      // this.formData.phase_drug_field.field_1=phase_drug_field.field_1
      // this.lastTime=new Date(this.timeStr.replace(/-/g,"/"))
    },
    async GetData() {
      if (this.$route.query.patient_id) this.formData.patient_id = this.$route.query.patient_id
      if (this.$route.query.idsn) this.formData.idsn = this.$route.query.idsn
      if (this.$route.query.name) this.formData.name = this.$route.query.name
      this.mobileReadonly = false
      this.staffName = this.publicWelfareStaff.checkin_info.name

      console.log('当前addpatient页为 添加新用户')
      let pres = await GetProvince()
      const parr = pres.data
      this.provinceArr = []
      this.provinceArr = Object.values(parr)
      let mres = await GetMode()
      const marr = mres.data
      this.modeArr = []
      for (let i in marr) {
        this.modeArr.push({
          name: marr[i],
          value: i
        })
      }
      if (this.formData.city) {
        let cres = await GetCity({
          province: this.provinceName
        })
        const carr = cres.data
        this.cityArr = []
        this.cityArr = Object.values(carr)
        if (carr.length < 1) {
          this.cityArr.unshift('该省份下暂无城市')
        }
        let hres = await GetHospital({
          province: this.provinceName,
          city: this.cityName
        })
        this.hospitalArr = []
        this.hospitalArr = hres.data
        if (this.hospitalArr.length < 1) {
          this.hospitalArr.unshift({
            name: '该城市下暂无项目医院',
            id: ''
          })
        }
        let drres = await GetDrugstore({
          province: this.provinceName,
          city: this.cityName
        })
        this.drugstoreArr = []
        this.drugstoreArr = drres.data
        if (this.drugstoreArr.length < 1) {
          this.drugstoreArr.unshift({
            name: '该城市下暂无领药药房',
            id: ''
          })
        }
        if (this.formData.hospital_id) {
          let dores = await GetDoctor({
            hospital_id: this.formData.hospital_id,
            role: '医生'
          })
          const doarr = dores.data
          this.doctorArr = []
          for (let i in doarr) {
            this.doctorArr.push({
              name: doarr[i],
              value: i
            })
          }
          if (doarr.length < 1) {
            this.doctorArr.unshift({
              name: '该医院下暂无项目医生',
              value: ''
            })
          }
        }
        if (this.formData.city) {
          let volunteers = getVolunteers({
            province: this.formData.province,
            city: this.formData.city
          })
          const volunteer = volunteers.data
          this.staffArr = []
          for (let i in volunteer) {
            this.staffArr.push({
              name: volunteer[i],
              value: i
            })
          }
          if (volunteer.length < 1) {
            this.staffArr.unshift({
              name: '该城市下暂无公益专员',
              value: ''
            })
          }
        }
        this.modeName = await this.modeArr.filter(item => item.value == this.formData.mode_id)[0].name
      }
      Toast.clear()
    },
    checkMobile(val, index) {
      if (!checkCellphone(val)) {
        if (index == 1) {
          this.mobileErr1 = true
          Toast('手机号格式有误！')
        }
        if (index == 2) {
          this.mobileErr2 = true
          Toast('紧急联系人电话格式有误！')
        }
        console.log('手机号格式有误！', index)
        return false
      } else {
        if (index == 1) this.mobileErr1 = false
        if (index == 2) this.mobileErr2 = false
        return true
      }
    },
    checkIdsn(val) {
      if (!isIdCardNo(val)) {
        this.idsnErr = true
        Toast('请输入正确的身份证号码！')
        return false
      } else {
        this.idsnErr = false
        return true
      }
    },
    timeFormat(time) {
      let year = time.getFullYear()
      let month = time.getMonth() + 1
      let day = time.getDate()
      return year + '-' + month + '-' + day
    },
    Changecity(picker, values) {
      this.formData.province = values[0]
      this.getCity()
    },
    openIdsn() {
      if (this.idsnReadonly) return
      this.showIdsnPicker = true
    },
    openProvince() {
      this.showProvince = true
    },
    async onProvince(value, index) {
      this.formData.province = value
      this.provinceName = value
      Toast.loading({
        duration: 0, // 持续展示 toast
        overlay: true,
        forbidClick: true
      })
      this.showProvince = false
      let cres = await GetCity({
        province: value
      })
      const carr = cres.data
      this.cityArr = []
      this.formData.city = ''
      this.cityName = '请选择城市'

      this.hospitalArr = []
      this.formData.hospital_id = ''
      this.hospitalName = '请选择项目医院'

      this.doctorArr = []
      this.formData.doctor_id = ''
      this.doctorName = '请选择项目医生'

      this.formData.drugstore_id = ''
      this.drugstoreName = '请选择项目药房'
      this.drugstoreArr = []

      this.formData.volunteer_id = ''
      // this.staffName = '请选择公益专员'
      this.staffArr = []

      this.cityArr = Object.values(carr)
      if (carr.length < 1) {
        this.cityArr.unshift('该省份下暂无城市')
      }
      await Toast.clear()
    },
    openCity() {
      if (this.cityArr.length < 1) {
        Toast('请先选择“所属省份”')
        return
      }
      this.showCity = true
    },
    async onCity(value, index) {
      this.formData.city = value
      this.cityName = value
      Toast.loading({
        duration: 0, // 持续展示 toast
        overlay: true,
        forbidClick: true
      })
      this.showCity = false
      let hres = await GetHospital({
        province: this.formData.province,
        city: value
      })
      this.hospitalArr = []
      this.formData.hospital_id = ''
      this.hospitalName = '请选择项目医院'

      this.doctorArr = []
      this.formData.doctor_id = ''
      this.doctorName = '请选择项目医生'

      this.formData.drugstore_id = ''
      this.drugstoreName = '请选择项目药房'
      this.drugstoreArr = []

      this.formData.volunteer_id = ''
      // this.staffName = '请选择公益专员'
      this.staffArr = []

      this.hospitalArr = hres.data
      if (this.hospitalArr.length < 1) {
        this.hospitalArr.unshift({
          name: '该城市下暂无项目医院',
          id: ''
        })
      }
      await getVolunteers({
        province: this.formData.province,
        city: this.formData.city
      }).then(res => {
        console.log('getVolunteers接口返回:', res)
        this.staffArr == []
        this.staffArr = res.data
        this.formData.volunteer_id = ''

        if (this.staffArr.length < 1) {
          this.staffArr.unshift({
            name: '该城市下暂无公益专员',
            value: ''
          })
        }
      })
      let drres = await GetDrugstore({
        province: this.formData.province,
        city: value
      })
      this.drugstoreArr = []
      // const drarr = drres.data
      this.drugstoreArr = drres.data
      // this.formData.drugstore_id = ''
      // this.drugstoreName = '请选择领药药房'
      // for(let i in drarr) {
      //   this.drugstoreArr.push({
      //     name: drarr[i],
      //     value: i
      //   })
      // }
      if (this.drugstoreArr.length < 1) {
        this.drugstoreArr.unshift({
          name: '该城市下暂无领药药房',
          id: ''
        })
      }
      await Toast.clear()
    },
    openHospital() {
      if (this.hospitalArr.length < 1) {
        Toast('请先选择“所属城市”')
        return
      }
      this.showHospital = true
    },
    async onHospital(value, index) {
      this.formData.hospital_id = value.id
      this.hospitalName = value.name
      Toast.loading({
        duration: 0, // 持续展示 toast
        overlay: true,
        forbidClick: true
      })
      this.showHospital = false
      this.doctorArr = []
      this.formData.doctor_id = ''
      if (value.id) {
        let dores = await GetDoctor({
          hospital_id: value.id,
          role: '医生'
        })
        const doarr = dores.data
        this.doctorName = '请选择项目医生'
        for (let i in doarr) {
          this.doctorArr.push({
            name: doarr[i],
            value: i
          })
        }
        if (doarr.length < 1) {
          this.doctorArr.unshift({
            name: '该医院下暂无项目医生',
            value: ''
          })
        }
      }

      await Toast.clear()
    },
    openDoctor() {
      if (this.doctorArr.length < 1) {
        Toast('请先选择“项目医院”')
        return
      }
      this.showDoctor = true
    },
    onDoctor(value, index) {
      this.formData.doctor_id = value.value
      this.doctorName = value.name
      this.showDoctor = false
    },
    openStaff() {
      if (this.staffArr.length < 1) {
        Toast('请先选择“所属城市”')
        return
      }
      this.showStaff = true
    },
    onStaff(value) {
      // console.log(value)
      this.staffName = value.name
      this.formData.volunteer_id = value.id
      this.showStaff = false
      // console.log("onStaff",value,this.formData.volunteer_id)
    },
    openDiseaseType() {
      this.showMode = true
    },
    openMode() {
      this.showMode = true
    },
    onMode(value, index) {
      this.formData.mode_id = value.value
      this.modeName = value.name
      this.showMode = false
    },
    openDiseaseStage() {
      this.showDiseaseStage = true
    },
    onDiseaseStage(value) {
      if (!this.formData.field_6) {
        Toast('请先选择“疾病类型”')
        return
      }
      // this.formData.field_6 = ''
      // this.patientType = '请选择疾病类型'
      this.diseaseStage = value
      this.formData.field_3 = this.diseaseStage
      this.showDiseaseStage = false
      if (this.noCheckPatientType) {
        this.formData.field_6 = `${this.diseaseStage}${this.patientType}`
      }
    },
    openPatientType() {
      // if(!this.formData.field_3) {
      //   Toast('请先选择“疾病分期”')
      //   return
      // }
      // if(this.formData.field_3 === 'Ⅳ期') {
      //   this.patientTypeArr = ['鳞状非小细胞肺癌','非鳞状非小细胞肺癌']
      // } else {
      //   this.patientTypeArr = ['鳞状非小细胞肺癌','非鳞状非小细胞肺癌']
      // }
      this.showPatientType = true
    },
    onPatientType(value) {
      if (!this.formData.field_6 === value) {
        this.showPatientType = false
        return
      }
      this.formData.field_3 = ''
      this.diseaseStage = '请选择疾病分期'
      this.patientType = value
      this.formData.field_6 = this.patientType
      this.showPatientType = false
      console.log('this.patientType', this.patientType)
    },
    openTreatment() {
      this.showTreatment = true
    },
    onTreatment(value) {
      if (value == '是') {
        this.showFirstTreatmentDate = true
        this.startTreatment = value
      } else if (value == '否') {
        this.showFirstTreatmentDate = false
        this.startTreatment = value
        // this.showNextTimeCell=false
      }
      this.formData.field_1 = value
      this.showTreatment = false
    },
    openDatePicker(index) {
      if (index == 1) this.showDatePicker1 = true
      if (index == 2) this.showDatePicker2 = true
    },
    onFirstTreatmentDate(value) {
      this.firstTreatmentDate = value
      this.FirstTimeStr = this.timeFormat(value)
      this.formData.field_2 = this.timeFormat(value)
      this.showDatePicker1 = false
    },
    onLatestTreatmentDate(value) {
      this.latestTreatmentDate = value
      this.timeStr = this.timeFormat(value)
      this.formData.phase_drug_field.field_1 = this.timeFormat(value)
      this.showDatePicker2 = false
      this.showNextTime = true
    },
    onNextTime() {
      this.lastTime = this.latestTreatmentDate //记录历史值
      this.showNextTime = false
      this.showNextTimeCell = true
    },
    onCancel() {
      // this.showNextTimeCell=false;
      this.showNextTime = false
      setTimeout(() => {
        if (this.lastTime == '') {
          this.timeStr = '请选择'
          this.formData.phase_drug_field.field_1 = ''
        } else {
          this.formData.phase_drug_field.field_1 = this.timeFormat(this.lastTime)
          this.latestTreatmentDate = this.lastTime
          this.timeStr = this.timeFormat(this.lastTime)
        }
      }, 300)
    },
    deleteCI() {
      Dialog.confirm({
        message: '确定删除？'
      }).then(() => {
        this.formData.photo = []
      })
    },

    openDrugstore() {
      if (this.drugstoreArr.length < 1) {
        Toast('请先选择“所属城市”')
        return
      }
      this.showDrugstore = true
    },
    onDrugstore(value, index) {
      this.formData.drugstore_id = value.id
      this.drugstoreName = value.name
      this.showDrugstore = false
    },
    getPhoto(image) {
      // console.log("input-get",image)
    },
    goTimeline() {
      this.$router.push({ name: 'patientManage' })
    },
    //提交
    next() {
      this.formData.current_volunteer_id = this.publicWelfareStaff.checkin_info.papid
      this.formData.volunteer_id = this.publicWelfareStaff.checkin_info.papid

      // return
      // console.log("photoArr",this.photoArr)
      if (this.photoArr.length > 0) this.formData.photo = this.photoArr[0].src
      console.log('提交数据:', this.formData)
      if (!this.formData.hospital_id) delete this.formData.hospital_id
      if (!this.formData.drugstore_id) delete this.formData.hospital_id
      if (!this.formData.doctor_id) delete this.formData.doctor_id
      if (!this.formData.field_7) delete this.formData.field_7
      if (!this.formData.field_8) delete this.formData.field_8
      // field_1:'',//是否开始治疗
      // field_2:'',//第一次治疗时间
      // field_6:'',//疾病类型
      // field_7:'',//紧急联系人姓名
      // field_8:'',//紧急联系人电话
      // phase_drug_field:{//阶段自定义字段
      // phase_drug_field.field_1:'' //最近一次输注时间
      if ((!this.nameReadonly && !this.formData.name) || (!this.mobileReadonly && !this.formData.mobile) || (!this.idsnReadonly && !this.formData.idsn) || !this.formData.province || !this.formData.city || !this.formData.volunteer_id || !this.formData.mode_id || !this.formData.field_1 || (this.showFirstTreatmentDate && !this.formData.field_2) || !this.formData.field_6 || !this.formData.phase_drug_field.field_1 || !this.formData.photo.length > 0) {
        Notify({
          message: '请完善信息',
          color: '#FF4830',
          background: '#FFDADB'
        })
        return false
      }
      if (this.noCheckPatientType && !this.formData.field_3) {
        Notify({
          message: '请完善信息',
          color: '#FF4830',
          background: '#FFDADB'
        })
        return false
      }
      //验证电话号码

      if (!this.checkMobile(this.formData.mobile, 1)) {
        console.log('检查电话1未通过')
        return
      }
      if (this.formData.field_8) {
        //填了联系人电话,但是格式不对
        if (!this.checkMobile(this.formData.field_8, 2)) {
          console.log('检查电话2未通过')
          return
        }
      }
      //验证身份证号
      if (!this.checkIdsn(this.formData.idsn)) {
        console.log('检查身份证未通过')
        return
      }

      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true
      })
      this.submitBtnDisabled = true
      // console.log("通过!")
      // return
      Apply(this.formData)
        .then(res => {
          this.$router.replace({
            name: 'staffMsg',
            query: {
              title: '注册成功',
              btnText: '返回列表',
              statusText: '你已为患者注册成功',
              notice: '请及时通知患者登录微信，做人脸识别和签署知情同意书。',
              route: 'patientManage'
            }
          })
          Toast.clear()
          this.submitBtnDisabled = false
        })
        .catch(err => {
          this.submitBtnDisabled = false
          Toast.clear()
          Toast(err.response.data.message)
        })
    },
    showPic(route, index) {
      console.log('预览图片-路径,序号:', route, index)
      this.src = []
      if (Array.isArray(route)) {
        route.forEach(ele => {
          this.src.push(ele.filepath)
        })
      } else {
        this.src.push(route)
      }
      this.$nextTick(() => {
        ImagePreview({
          images: this.src,
          showIndex: true,
          loop: false,
          startPosition: index ? index : 0
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.addPatient {
  // height: 100%;
  // width: 100%;
  background-color: #f6f6f6;
  .title {
    background-color: white;
    padding: 10px 15px;
    font-size: 14px;
  }

  /deep/ .noborder.van-cell::after {
    border-bottom: none !important;
  }
  .btn {
    display: flex;
    justify-content: space-between;
    width: auto;
    padding: 10px;
    background-color: white;
    margin: 0;
    .van-button {
      margin: 0 5px;
      white-space: nowrap;
    }
    .btn1 {
      flex-grow: 1;
    }
    .btn2 {
      flex-grow: 4;
    }
  }
  .group2 {
    .van-cell__value {
      flex: 1.5 0 !important;
    }
  }
  .group3 {
    .van-cell__title {
      flex: 1.5 0 !important;
    }
  }
  .nowrap {
    white-space: nowrap;
  }
  .van-cell--required {
    &::before {
      content: '*';
    }
  }
  .van-overlay {
    background-color: fade(#000, 60%);
  }

  //修改图片上传的样式
  ::v-deep.van-cell-group__title {
    padding: 0;
  }
  ::v-deep.uploader-subtitle {
    padding: 0 0 10px 0;
  }
}
</style>
